import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { tomos } from '../data/constants';
import { Check, ChevronDown } from 'lucide-react';
export function ProductOverview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const includes = ['Planificación semanal lista para ejecutar', '40 clases completas con todos los bloques', 'Progresión de carga semana a semana', 'Benchmarks y tests con fichas de registro', 'Progresiones y regresiones por nivel', 'Cues técnicos listos para decir en clase', 'Métodos nuevos explicados para el profe', 'Circuitos, AMRAP, For Time, EMOM listos', '100% aplicable con material estándar'];
  return <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-276">
      <div className="text-center mb-16" data-id="element-277">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-278">
          🏆 COMBO COMPLETO DE E. FUNCIONAL
        </h2>
        <p className="text-xl text-zinc-400 mb-2" data-id="element-279">
          6 Tomos + 6 Bonos — Adaptación → Peak Performance
        </p>
        <p className="text-primary font-bold" data-id="element-280">
          300 páginas — 240 clases completas — Todo resuelto.
        </p>
      </div>

      {/* Tomos Pills */}
      <div className="flex flex-wrap justify-center gap-3 mb-16" data-id="element-281">
        {tomos.map(t => <div key={t.id} className="px-4 py-2 rounded-full border border-primary/40 bg-primary/10 text-primary text-sm font-bold flex items-center gap-2" data-id="element-282">
            <span data-id="element-283">{t.id}</span>
            <span className="text-white" data-id="element-284">{t.name.split(' ')[0]}</span>
          </div>)}
      </div>

      <div className="mb-16" data-id="element-285">
        <h3 className="text-2xl font-bold mb-3 text-center flex items-center justify-center gap-2" data-id="element-286">
          <span data-id="element-287">📘</span> 6 TOMOS COMPLETOS
        </h3>
        <p className="text-center text-zinc-400 mb-8" data-id="element-288">
          Sistema Anual Progresivo — Tocá un tomo para ver el contenido
        </p>

        <div className="space-y-3" data-id="element-289">
          {tomos.map((t, i) => {
          const isOpen = openIndex === i;
          return <div key={t.id} className={`rounded-xl border overflow-hidden transition-colors duration-200 ${isOpen ? 'bg-surface border-primary shadow-[0_0_20px_rgba(74,222,128,0.15)]' : 'bg-surface border-zinc-800 hover:border-primary/40'}`} data-id="element-290">
                <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex items-center justify-between gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-291">
                  <div className="flex items-center gap-3 md:gap-4 min-w-0" data-id="element-292">
                    <span className="text-2xl md:text-3xl shrink-0" data-id="element-293">
                      {t.icon}
                    </span>
                    <div className="min-w-0" data-id="element-294">
                      <div className="font-bold text-white text-base md:text-lg" data-id="element-295">
                        Tomo {i + 1} — {t.name}
                      </div>
                      <div className="text-xs md:text-sm text-primary font-medium" data-id="element-296">
                        {t.months}
                      </div>
                    </div>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-primary shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-297" />
                </button>

                <AnimatePresence data-id="element-298">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-299">
                      <div className="px-5 pb-5 md:px-6 md:pb-6 text-zinc-300 text-sm md:text-base leading-relaxed border-t border-primary/20 pt-4" data-id="element-300">
                        {t.content}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>

      <div className="bg-surface border border-zinc-800 rounded-2xl p-8" data-id="element-301">
        <h4 className="text-xl font-bold mb-6 text-center" data-id="element-302">
          Cada tomo incluye:
        </h4>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-303">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-304">
              <div className="mt-1 bg-primary/20 p-1 rounded-full" data-id="element-305">
                <Check className="w-3 h-3 text-primary" data-id="element-306" />
              </div>
              <span className="text-zinc-300 text-sm" data-id="element-307">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}